import { useQuery } from "@tanstack/react-query";
import { essaysApi } from "@/shared/api/endpoints";
import { qk } from "@/shared/api/queryKeys";

const COUNT_PARAMS = { limit: 1 };

/** Essays waiting for a grade, for the sidebar badge (refreshed every minute; undefined while unknown). */
export function usePendingEssayCount(enabled = true): number | undefined {
  const q = useQuery({
    queryKey: qk.essays.pending(COUNT_PARAMS),
    queryFn: () => essaysApi.pending(COUNT_PARAMS),
    select: (p) => p.total,
    enabled,
    staleTime: 30_000,
    refetchInterval: 60_000,
  });
  return q.data;
}
